module.exports = __webpack_public_path__ + "img/fondo_app.9c2b6d15.jpg";